module.exports = __webpack_public_path__ + "media/el_alquimista_hotel.3a7e029a.mp4";